import {
  AlertLayer as AlertLayerComponent,
  type WithFocusLockProps,
  withFocusLock,
} from '@volkswagen-onehub/components-core';
import type {
  AlertLayerOptionsV2,
  LayerV2,
} from '@volkswagen-onehub/layer-manager';
import * as React from 'react';
import ReactDOM from 'react-dom';

import {LayerContent} from './layer-content';

export interface AlertLayerProps {
  readonly layer: LayerV2<unknown, AlertLayerOptionsV2>;
  readonly active: boolean;
  scrollElementRef(el: HTMLDivElement): void;
}

const Layer: React.FunctionComponent<AlertLayerProps> = (props) => {
  const {layer, active, scrollElementRef, ...ownProps} = props;

  return (
    <AlertLayerComponent
      {
        ...ownProps /* Used to pass through the animation props */
      }
      scrollElementRef={(el: HTMLDivElement) => {
        scrollElementRef(ReactDOM.findDOMNode(el) as HTMLDivElement);
      }}
      active={active}
      aria-labelledby={layer.options['aria-labelledby']}
    >
      <LayerContent layer={layer} />
    </AlertLayerComponent>
  );
};

const AlertLayerWithLock = withFocusLock<AlertLayerProps>(Layer);
AlertLayerWithLock.displayName = 'AlertLayerWithLock';

export const AlertLayer: React.ElementType = (
  props: AlertLayerProps & WithFocusLockProps,
) => {
  return <AlertLayerWithLock {...props} disabled={props.layer.isClosed} />;
};
